import { render, staticRenderFns } from "./NotificationsById.vue?vue&type=template&id=2e41de30&"
import script from "./NotificationsById.vue?vue&type=script&lang=js&"
export * from "./NotificationsById.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports